import { render } from "./CastellEdit-Component.vue?vue&type=template&id=d9a78d5e"
import script from "./CastellEdit-Component.vue?vue&type=script&lang=js"
export * from "./CastellEdit-Component.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__